import { createSelector } from '@app/utils/createSelector'
import { toE164 } from '@app/utils/phoneTools/toE164'

import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { configSelector } from '@app/store/slices/config'
import { profileUserSelector } from '@app/store/slices/profile'
import { profileRegionResultSelector } from '@app/store/slices/profile_place'

export { configSelector }

export const stateSelector = (state: unknown) => state

export const isAppSelector = createSelector([configSelector], config => config.isApp)

export const supportAvatarUrlSelector = createSelector([configSelector], config => config.supportAvatarUrl)

/**
 * Support number of the region the header is showing. The region cascades — the signed-in
 * user's place, else the place cookie a visitor picked, else the default region — so a guest
 * has one too, which the old profile-only lookup could not give them.
 *
 * The sitter number is for someone who is one; everyone else, guests included, gets the
 * parent number. `null` when that region carries none, so no pill is drawn.
 */
export const supportPhoneResultSelector = createSelector([profileUserSelector, profileRegionResultSelector], (user, regionResult) =>
  createLoadable(c => {
    const region = c.unwrap(regionResult)
    const phone = user?.account_type === 'sitter' ? region.attributes.sitter_support_phone : region.attributes.parent_support_phone
    return phone ? toE164(phone) : null
  })
)

export const cloudPaymentsIdSelector = createSelector([configSelector], config => config.cloudpayments)

export const metaCorpEnabledSelector = createSelector([configSelector], config => config.country !== 'RU' || config.metaCorpEnabled)

/**
 * AutoSizeTextArea typing is wrong and requires
 * following two properties to be present even though they are optional
 */
export const TEXTAREA_TYPE_FIX: {
  onPointerEnterCapture: undefined
  onPointerLeaveCapture: undefined
} = {} as any
